import React, { ReactNode } from "react";

interface ControlButtonProps {
  text?: string;
  icon?: ReactNode;
  onClick: () => void;
  disabled?: boolean;
}

const ControlButton: React.FC<ControlButtonProps> = ({ text, icon, onClick, disabled }) => {
  return (
    <button
      onClick={onClick}
      type="button"
      disabled={disabled}
      className="px-4 py-2 text-sm font-medium text-secondary-700 bg-white border border-secondary-200 rounded-lg hover:bg-secondary-50 hover:border-secondary-300 transition-all duration-200 focus:outline-none focus:ring-2 focus:ring-primary-500 focus:ring-offset-2 disabled:opacity-50 disabled:cursor-not-allowed disabled:hover:bg-white disabled:hover:border-secondary-200 flex items-center gap-2"
    >
      {icon && <span>{icon}</span>}
      {text && <span>{text}</span>}
    </button>
  );
};

export { ControlButton };
